import React from 'react';
import {Box, Typography} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const AppLogo = () => {
  return (
    <Box
      sx={{
        height: {xs: 56, sm: 70},
        padding: {xs: 1, sm: 2.5},
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        gap: {xs: 1, sm: 1.5},
      }}
      className='app-logo'
    >
      <WhatsAppIcon
        sx={{
          fontSize: {xs: 32, sm: 45},
          color: '#616161',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <Typography
          variant='h5'
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            lineHeight: 1.2,
            fontSize: {xs: '1.1rem', sm: '1.5rem'},
          }}
        >
          Muraasala
        </Typography>
        <Typography
          variant='caption'
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem',
            letterSpacing: '0.5px',
            display: {xs: 'none', sm: 'block'},
          }}
        >
          WhatsApp Platform
        </Typography>
      </Box>
    </Box>
  );
};

export default AppLogo;
